var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-information"},[_c('b-form-select',{attrs:{"options":_vm.modulesForTrainerPreparationOptions},on:{"change":_vm.onModuleSelected},model:{value:(_vm.moduleSelected),callback:function ($$v) {_vm.moduleSelected=$$v},expression:"moduleSelected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }